import {ServiciosPage} from './ServiciosPage';
export default ServiciosPage;